import React from "react";
import { graphql, StaticQuery } from "gatsby";
import Prose from "../utility/prose";
import DocumentCard from "../utility/documentCard";

class Documents extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            sort: "Date",
        }
        this.setSort = this.setSort.bind(this)
        this.getCards = this.getCards.bind(this)
    }

    setSort(sortto) {
        this.setState({ sort: sortto})
    }

    getCards() {
        if (this.state.sort === 'Date') {
            return this.props.documentsDate.map(document => (
                <DocumentCard key={document.id} document={document} />
            ))
        } else {
            return this.props.documentsAZ.map(document => (
                <DocumentCard key={document.id} document={document} />
            ))
        }
    }

    render() {
        let inactive = `bg-stone-200 dark:bg-stone-600 px-4 py-1 rounded-full mr-2 last:mr-0`
        let active = `bg-emerald-300 dark:bg-emerald-600 px-4 py-1 rounded-full mr-2 last:mr-0`
        return (
            <Prose>
            <div className="">
                <div className="text-center mb-12">
                    <h2>Sort By</h2>
                    <button onClick={() => this.setSort('Date')} className={this.state.sort == "Date" ? active : inactive}>Date Published</button>
                    <button onClick={() => this.setSort('A-Z')}  className={this.state.sort == "A-Z" ? active : inactive}>A-Z</button>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    <this.getCards />
                </div>
            </div>
            </Prose>
        )
    }
}

export default () => (
    <StaticQuery query={graphql`
        query {
            documentsDate: allStrapiDocument(sort: {publish_date: DESC}) {
                nodes {
                    id
                    title
                    publish_date
                    document {
                        localFile {
                            publicURL
                            prettySize
                        }
                    }
                    attachments {
                        id
                        title
                        file {
                            localFile {
                                publicURL
                                prettySize
                            }
                        }
                    }
                }
            }
            documentsAZ: allStrapiDocument(sort: {title: ASC}) {
                nodes {
                    id
                    title
                    publish_date
                    document {
                        localFile {
                            publicURL
                            prettySize
                        }
                    }
                    attachments {
                        id
                        title
                        file {
                            localFile {
                                publicURL
                                prettySize
                            }
                        }
                    }
                }
            }
        }
    `}
    render={(data) => (
        <Documents documentsDate={data.documentsDate.nodes} documentsAZ={data.documentsAZ.nodes} />
    )} 
    />
)
